import { useEffect, useState } from "react";
import { Box, makeStyles, Typography } from "@material-ui/core";
import { fontUnit } from "../../utils/DeviceManager";
import iconBike from '../../assets/img/product_bike.png';
import iconTruck from '../../assets/img/product_truck.png';
// import iconAgriculturalTruck from '../../assets/img/product_agriculturalTruck.png';
import iconLand from '../../assets/img/product_land.png';
import iconCar from '../../assets/img/product_car.png';
import iconTractor from '../../assets/img/product_tractor.png';
import iconGold from '../../assets/img/product_gold.png';
// import iconCard from '../../assets/img/credit_card_blue.png';
import iconCarInsurance from '../../assets/img/product_carInsurance.png';
// import iconMobileLoan from '../../assets/img/product_namo.png';
import iconMobileLoan from '../../assets/svg/product_namo.svg';

export interface ProductCardProps {
    //accountType: string;
    accountName: string;
    accountNo: string;
    loanGroup: string;
}

// add mature product
export function ProductCard(props: ProductCardProps) {
    const { loanGroup, accountName, accountNo = ""} = props;
    const classes = useStyles();
    const [img, setImg] = useState(iconCar);

    useEffect(() => {
        switch (loanGroup) {
            //TODO get new field from BE (ex. as loanGroup) 
            // case "TLMG":
            // case "REMG":
            // case "ULCR":
            // case "REUC":
            // case "ULMC": // mature product
            // case "RUMC": // mature product
            // case "APCA": //MVP10 SP2*
            case "CAR":
                return setImg(iconCar);
            // case "ULMB":
            // case "REUM":
            // case "ULMM": // mature product
            // case "RUMM": // mature product
            // case "APMA": //MVP10 SP2*
            case "BIKE":
                return setImg(iconBike);
            // case "TLTK":
            // case "TLT1":
            // case "TLTKK":
            // case "TDTK":
            // case "RET1":
            // case "RETK":
            // case "TRTK":
            // case "APTA": //MVP10 SP2
            case "TRUCK":
                return setImg(iconTruck);
            //case "INSI":
            case "INSURANCE":
                return setImg(iconCarInsurance);
            // case "TLA1":
            // case "TLAI":
            // case "TLAS":
            // case "REA1":
            // case "REAI":
            // case "REAS":
            // case "TDAI":
            // case "TRAI":
            // case "TR1S":
            // case "TD1S":
            // case "APAA": //MVP10 SP2
            case "TRACTOR":
                return setImg(iconTractor);
            // TO support title loan Land deed , MVP8 ,DTD-6315
            // case "TLTI":
            // case "RETI":
            // case "TLL1":
            // case "TLTD":
            // case "RED1":
            // case "RETD":
            // case "APLA":  //MVP10 SP2
            case "TITLEDEED":
                return setImg(iconLand);
            //case "REG1":
            case "GOLD":
                return setImg(iconGold);
            //case "NAMO": //MVP10 SP2 MOBILE LOAN
            case "MOBILE":
                return setImg(iconMobileLoan);
        }
    }, []);

    return (
        <div style={{
            fontSize: fontUnit(16),
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        }}>
            <div className={classes.accountContainer}>
                <img src={img} alt={'icon'} className={classes.icon} />
                <div className={classes.accountDetail}>
                    <Typography className={classes.accountName}>{accountName}</Typography>
                    <Typography style={{ fontFamily: "Prompt-Light", fontSize: 14 }}>{accountNo == null ? "" : accountNo}</Typography>                </div>
            </div>
        </div>
    )
}

const useStyles = makeStyles({
    icon: {
        height: '100%',
        verticalAlign: 'middle',
        marginRight: 10,
        borderRadius: '8px',
    },
    accountContainer: {
        display: 'flex',
        width: '100%',
        height: '44px',
        paddingBottom: 16,
    },
    accountDetail: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        fontSize: fontUnit(16),
    },
    accountName: {
        fontSize: fontUnit(16),
        fontWeight: 600,
    },
}, { name: 'ProductCard' })